import { Container, Typography, Button } from "@mui/material";
import { useLocales } from "../../../locales";
import { Box } from "@mui/system";

export const MembersOnlyEvent = ({ account, event }) => {
    const { translate } = useLocales();

    return (
        <Container maxWidth="md" sx={{ mt: 8, textAlign: 'center' }}>
            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '70vh' }}>
                <Typography variant="h3" gutterBottom>
                    {translate('event_page.members_only.title')}
                </Typography>
                <Typography variant="body1" sx={{ mb: 4 }}>
                    {translate('event_page.members_only.message')}
                </Typography>
            </Box>
            {/* <Button
                variant="contained"
                color="primary"
                onClick={() => window.location.href = `/seller/${account.handler}/subscriptions`}
            >
                {translate('event_page.members_only.cta')}
            </Button> */}
        </Container>
    );
}; 